import React from 'react';
import styled from 'styled-components';
// import styled from 'styled-components';


// import GlobalStyled from '../styles/GlobalStyle';

function PropertyDescription({description}){
    return (
        <PropDescription>{description}</PropDescription>
    )
}

const PropDescription = styled.p`
    // border:solid 2px red;
    width:75%;
    // font-size:.2rem;
    padding:0 .5rem;
    margin:0 auto;
    text-align:left;
    content-justify:center;
    align-items:center;
`;

export default PropertyDescription;